const shuttles = {
  shuttles: 'Shuttles',

  toast: {
    error: {
      badResponse: '[Shuttle] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Shuttle] actualizado correctamente',
      },
      delete: {
        default: '[Shuttle] eliminado correctamente',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el Shuttle',
    },
    successToast: {
      message: '¡Éxito! El Shuttle se ha añadido correctamente',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el Shuttle',
    },
    successToast: {
      message: '¡Éxito! El Shuttle se actualizó correctamente',
    },
  },

  createNew: 'Crear',
  deleteBtn: 'Eliminar',

  deleteModal: {
    header: 'Eliminar Shuttlees',
    body: 'Está a punto de eliminar {{num}} Shuttlees.',
  },
  table: {
    headers: {
      id: 'ID',
      line: 'Línea',
      direction: 'Dirección',
      weekdays: 'Días de semana',
      supplier: 'Proveedor',
      pax: 'Pax',
    },
    notAvailable: 'No disponible',
    actions: {
      duplicate: 'Duplicar',
      delete: 'Eliminar',
      export: 'Exportar',
    },
  },

  form: {
    header: {
      createShuttle: {
        title: 'Nuevo Shuttle',
      },

      updateShuttle: {
        title: 'Shuttle',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    info: {
      details: {
        header: {
          create: 'Crear Shuttle',
          edit: 'Editar Shuttle',
          information: 'Información del Shuttle',
        },
        shuttleBy: {
          flexibleTime: 'Tiempo flexible',
          fixedTime: 'Tiempo fijo',
        },
        fields: {
          unit: 'Sitio',
          supplier: 'Operado por',
          hour1: 'De',
          hour2: 'Hacia',
          shuttleBy: 'Transporte por',
          code: 'Código',
          name: 'Nombre',
          area: 'Zona',
          line: 'Línea',
          profile: 'Perfil',
          direction: 'Dirección',
          weekDays: 'Días de la semana',
          drivers: 'Conductores',
          pax: 'Pax',
          paymentType: 'Tipo de pago',
          routingType: 'Tipo de ruta',
        },
        paymentTypeOptions: {
          free: 'Libre',
          opusCard: 'Tarjeta opus',
          cashOnBoard: 'Efectivo a Bordo',
          correspondance: 'Correspondencia',
        },
        routingTypeOptions: {
          dynamic: 'Dinámicos',
          demand: 'Demanda',
          bus: 'Autobús',
        },
      },
      times: {
        header: 'Tiempo',
        fields: {
          hour: 'Hora',
          limit: 'Límite',
          busses: 'Buses',
          holidays: 'Vacaciones',
        },
        btnAdd: 'Añadir hora',
      },
      stops: {
        header: 'Paradas',
        fields: {
          address: 'Dirección',
          name: 'Nombre',
          zone: 'Zona',
          save: 'Guardar',
        },
        btnAdd: 'Añadir parada',
      },
      zone: '(Zona: {{zone}})',
    },
    validation: {
      unitRequired: 'El sitio es obligatorio',
      codeRequired: 'El código es obligatorio',
      nameRequired: 'El nombre es obligatorio',
      paxRequired: 'Pax es obligatorio',
      hourRequired: 'La hora es obligatoria',
      limitRequired: 'El límite es obligatorio',
      latRequired: 'La latitud es obligatoria',
      lonRequired: 'Longitud que requiere',
    },
    weekDays: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sabado',
    },
  },
};

export default shuttles;
